import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userService } from "services/userService";
import { RootState } from "store";
import { login } from "store/apps/auth";

export default function useRefreshUserInfo() {
  const { user } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;

    (async () => {
      try {
        const result = await userService.getUserInfo();

        if (!result) return;

        dispatch(login(result));
      } catch (error) {}
    })();
  }, []);

  return {};
}
